import { UserRoles } from '@/enums';
import { Loans } from '@/modules/loans/types';

const access_roles = {
  [Loans.Pages.LOANS]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.CREDIT_MANAGER,
  ],
};

export default access_roles;
